<div style="display: flex;">
    <div style="display: flex; flex-flow: column; width: 50%;">
        <table>
            <tr *ngFor="let book of books$ | async" style="vertical-align: top;">
                <td>
                    <input type="checkbox" [checked]="book.isRead" (click)="updateBook(book)" />
                </td>
                <td>
                    <a [href]="'https://www.wikidata.org/wiki/'+book.wikidataId" target="_blank">
                        {{book.title}}
                    </a>
                </td>
                <td>{{book.author}}</td>
                <td>
                    <div style="display: flex; flex-flow: column;">
                        <div *ngFor="let win of book.awardWins" style="display: flex; flex-flow: nowrap;">
                            <div style="flex: 1" *ngIf="win.award == 0">Hugo</div>
                            <div style="flex: 1" *ngIf="win.award == 1">Nebula</div>
                            <div style="flex: 1" *ngIf="win.award == 2">Locus</div>
                            <div>{{win.year}}</div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div style="height: 20px;" *ngIf="loading && !error">
        <div class="lds-progress">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div *ngIf="error">Hubo un error</div>
</div>